export default __webpack_public_path__ + "static/media/login.44c5cdc1.jpg";